import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@/environments/environment';
import { getHeaders } from '../utils/headers.functions';

const apiUrl = environment.API_URL;

@Injectable({
    providedIn: 'root',
})


export class ApiService {
    updateFile(formData: FormData, id: any) {
        const user = JSON.parse(localStorage['currentUser']);
        return this.http.put<any>(`${apiUrl}/miveracruz/update_requirements_files/${id}/${user.id}`, formData);
    }

    getDocumentsByUserId(id: string) {
        const headers = getHeaders();
        return this.http.get<any>(`${apiUrl}/miveracruz/citizen_form_request_record/${id}`, { headers });
    }

    getUserData(id: string) {
        const headers= getHeaders();
        return this.http.get<any>(`${apiUrl}/v2/user/${id}`, { headers });
    }

    updateUser(id: string, body: any) {
        const headers = getHeaders();
        return this.http.put<any>(`${apiUrl}/v2/user/${id}`, body, { headers });
    }

    getTramitesByUser(id: string, limit: number = 10, offset: number = 0) {
        const headers = getHeaders();
        return this.http.get<any>(`${apiUrl}/miveracruz/citizen_form_request_by_user/${id}?limit=${limit}&offset=${offset}`, { headers });
    }

    getSolicitudes(limit: number = 10, offset: number = 0): Observable<any> {
        const headers = getHeaders();
        return this.http.get<any>(`${apiUrl}/miveracruz/citizen_form_request?limit=${limit}&offset=${offset}`, { headers });
    }

    getTramitesByArea(areaId: number): Observable<any[]> {
        const headers = getHeaders();
        return this.http.get<any[]>(`${apiUrl}/miveracruz/forms?area=${areaId}`, { headers });
    }

    getAllTramitesFiltered(pageSize: number, pageIndex: number, dependency: any, category: any, format: any) {
        return this.http.get<any>(`${apiUrl}/miveracruz/forms?limit=${pageSize}&offset=${pageIndex}&mode=En Línea&category=${category}&dependency=${dependency}`);
    }

    updateSurveyTramite(body: any): Observable<any> {
        const headers = getHeaders();
        return this.http.put<any>(`${apiUrl}/miveracruz/citizen_form_request`, body, { headers });
    }

    getCatalogInfo(name: string, limit: number, offset: number, search?: string) {
        let url = `${apiUrl}/catalogs-data/${name}?limit=${limit}&offset=${offset}`;
        if (search) {
            url += `&search=${encodeURIComponent(search)}`;
        }
        return this.http.get<any>(url);
    }

    getCatalogInfoById(name: string, id: number) {
        return this.http.get<any>(`${apiUrl}/catalogs-data/${name}/${id}`);
    }

    createCatalogInfo(name: string, body: any) {
        const headers = getHeaders();
        return this.http.post<any>(`${apiUrl}/catalogs-data/${name}`, body, { headers });
    }

    updateCatalogInfo(name: string, id: number, body: any) {
        const headers = getHeaders();
        return this.http.put<any>(`${apiUrl}/catalogs-data/${name}/${id}`, body, { headers });
    }

    deleteCatalogInfo(name: string, id: number) {
        const headers = getHeaders();
        return this.http.delete<any>(`${apiUrl}/catalogs-data/${name}/${id}`, { headers });
    }

    uploadFile(userid: any, documentid: any, name: any, formData: any) {
        return this.http.post<any>(`${apiUrl}/miveracruz/save_requirements_files/${userid}/${documentid}`, formData);
    }

    uploadFileV2(userid: any, requestid: any, documentid: any, name: any, formData: any) {
        return this.http.post<any>(`${apiUrl}/miveracruz/save_requirements_files/${userid}/${requestid}/${documentid}`, formData);
    }

    saveRequest(body: any) {
        const headers = getHeaders();
        return this.http.post<any>(`${apiUrl}/miveracruz/citizen_form_request`, body, { headers });
    }

    constructor(private http: HttpClient) { }

    uploadFielFile(body: FormData){
        return this.http.post<any>(`${apiUrl}/miveracruz/fielFiles`, body);
    }

    getFielFiles(){
        const headers = getHeaders();
        return this.http.get<any>(`${apiUrl}/miveracruz/fielFiles`, { headers });
    }

    updateFielFile(id: number | string, body: FormData){
        const headers = getHeaders('text/plain');
        console.log(`${apiUrl}/miveracruz/fielFiles/${id}`);
        return this.http.put<any>(`${apiUrl}/miveracruz/fielFiles/${id}`, body, { headers });
    }

    getAllTramites() {
        return this.http.get<any>(`${apiUrl}/miveracruz/forms`);
    }

    getAllTramitesPaged(limit: any, offset: any, search?: string) {
        let url = `${apiUrl}/miveracruz/forms?limit=${limit}&offset=${offset}`;
        if (search) {
            url += `&search=${encodeURIComponent(search)}`;
        }
        return this.http.get<any>(url);
    }

    getAllServiciosPaged(limit: any, offset: any) {
        return this.http.get<any>(`${apiUrl}/miveracruz/forms?limit=${limit}&offset=${offset}&type=servicio`);
    }

    getAllServiciosFiltered(pageSize: number, pageIndex: number, dependency: any, category: any, format: any) {
        return this.http.get<any>(`${apiUrl}/miveracruz/forms?limit=${pageSize}&offset=${pageIndex}&mode=En Línea&category=${category}&dependency=${dependency}&type=servicio`);
    }

    getTramiteFormById(tramiteId: string) {
        return this.http.get<any>(`${apiUrl}/miveracruz/forms/${tramiteId}`);
    }

    getSignatureByPasswd(body: string) {
        const headers = getHeaders();
        return this.http.post<any>(`${apiUrl}/miveracruz/get_signature`, body, { headers });
    }

    // Generic configuration methods
    getConfigById(id: any) {
        const headers = getHeaders();
        return this.http.get<any>(`${apiUrl}/config/${id}`, { headers });
    }

    createConfig(body: any) {
        const headers = getHeaders();
        return this.http.post<any>(`${apiUrl}/config`, body, { headers });
    }

    updateConfig(id: any, body: any) {
        const headers = getHeaders();
        return this.http.put<any>(`${apiUrl}/config/${id}`, body, { headers });
    }

    deleteConfig(id: any) {
        const headers = getHeaders();
        return this.http.delete<any>(`${apiUrl}/config/${id}`, { headers });
    }

    // Tracking 3D - Geolocalización de unidades
    getTrackingDashboard() {
        const headers = getHeaders();
        return this.http.get<any>(`${apiUrl}/tracking/dashboard`, { headers });
    }

    getTrackingUnits() {
        const headers = getHeaders();
        return this.http.get<any>(`${apiUrl}/tracking/units?_=${Date.now()}`, { headers });
    }

    /** Catálogo de unidades desde tabla tracking_unit (paginado y búsqueda) */
    getTrackingUnitsCatalog(limit: number, offset: number, search?: string) {
        const headers = getHeaders();
        let url = `${apiUrl}/tracking/units/catalog?limit=${limit}&offset=${offset}`;
        if (search) url += `&search=${encodeURIComponent(search)}`;
        return this.http.get<any>(url, { headers });
    }

    /** Una unidad del catálogo (tracking_unit) por id */
    getTrackingUnitCatalogById(id: number) {
        const headers = getHeaders();
        return this.http.get<any>(`${apiUrl}/tracking/units/catalog/${id}`, { headers });
    }

    getTrackingUnitLocation(uid: string) {
        const headers = getHeaders();
        return this.http.get<any>(`${apiUrl}/tracking/units/${uid}`, { headers });
    }

    getTrackingUnitHistory(uid: string, startDate?: string, endDate?: string) {
        let params = '';
        if (startDate) params += `?startDate=${encodeURIComponent(startDate)}`;
        if (endDate) params += `${params ? '&' : '?'}endDate=${encodeURIComponent(endDate)}`;
        
        const headers = getHeaders();
        return this.http.get<any>(`${apiUrl}/tracking/units/${uid}/history${params}`, { headers });
    }

    getTrackingUnitStatistics(uid: string, startDate?: string, endDate?: string) {
        let params = '';
        if (startDate) params += `?startDate=${encodeURIComponent(startDate)}`;
        if (endDate) params += `${params ? '&' : '?'}endDate=${encodeURIComponent(endDate)}`;
        
        const headers = getHeaders();
        return this.http.get<any>(`${apiUrl}/tracking/units/${uid}/statistics${params}`, { headers });
    }

    getTrackingDevices() {
        const headers = getHeaders();
        return this.http.get<any>(`${apiUrl}/tracking/devices`, { headers });
    }

    testTrackingAuthentication() {
        const headers = getHeaders();
        return this.http.post<any>(`${apiUrl}/tracking/authenticate`, {}, { headers });
    }

    // ── Programación (Limpia Pública) ────────────────────────────────────────

    createProgramacionBatch(payload: { fecha: string; turno: number; rutas: { ruta: number; unidad: string; operador_nombre?: string; notas?: string }[] }) {
        const headers = getHeaders();
        return this.http.post<any>(`${apiUrl}/programacion/batch`, payload, { headers });
    }

    getProgramacion(params: { limit?: number; offset?: number; fecha?: string; mes?: string; turno_id?: number } = {}) {
        const headers = getHeaders();
        const q = new URLSearchParams();
        if (params.limit != null)    q.set('limit',    String(params.limit));
        if (params.offset != null)   q.set('offset',   String(params.offset));
        if (params.fecha)            q.set('fecha',    params.fecha);
        if (params.mes)              q.set('mes',      params.mes);
        if (params.turno_id != null) q.set('turno_id', String(params.turno_id));
        const qs = q.toString() ? `?${q.toString()}` : '';
        return this.http.get<any>(`${apiUrl}/programacion${qs}`, { headers });
    }

    getProgramacionGrouped(params: { limit?: number; offset?: number; fecha?: string; mes?: string; turno_id?: number } = {}) {
        const headers = getHeaders();
        const q = new URLSearchParams();
        if (params.limit != null)    q.set('limit',    String(params.limit));
        if (params.offset != null)   q.set('offset',   String(params.offset));
        if (params.fecha)            q.set('fecha',    params.fecha);
        if (params.mes)              q.set('mes',      params.mes);
        if (params.turno_id != null) q.set('turno_id', String(params.turno_id));
        const qs = q.toString() ? `?${q.toString()}` : '';
        return this.http.get<any>(`${apiUrl}/programacion/grouped${qs}`, { headers });
    }

    getProgramacionBatchLog(params: { limit?: number; offset?: number } = {}) {
        const headers = getHeaders();
        const q = new URLSearchParams();
        if (params.limit  != null) q.set('limit',  String(params.limit));
        if (params.offset != null) q.set('offset', String(params.offset));
        const qs = q.toString() ? `?${q.toString()}` : '';
        return this.http.get<any>(`${apiUrl}/programacion/batch-log${qs}`, { headers });
    }

    getProgramacionCalendar(year: number, month: number) {
        const headers = getHeaders();
        return this.http.get<any>(`${apiUrl}/programacion/calendar?year=${year}&month=${month}`, { headers });
    }

    getProgramacionById(id: number) {
        const headers = getHeaders();
        return this.http.get<any>(`${apiUrl}/programacion/${id}`, { headers });
    }

    createProgramacion(body: any) {
        const headers = getHeaders();
        return this.http.post<any>(`${apiUrl}/programacion`, body, { headers });
    }

    updateProgramacion(id: number, body: any) {
        const headers = getHeaders();
        return this.http.put<any>(`${apiUrl}/programacion/${id}`, body, { headers });
    }

    deleteProgramacion(id: number) {
        const headers = getHeaders();
        return this.http.delete<any>(`${apiUrl}/programacion/${id}`, { headers });
    }

    getProgramacionSuscriptores(id: number) {
        const headers = getHeaders();
        return this.http.get<any>(`${apiUrl}/programacion/${id}/suscriptores`, { headers });
    }

    enviarNotificacionManualProgramacion(id: number, suscripcionId?: number) {
        const headers = getHeaders();
        const body = suscripcionId != null ? { suscripcion_id: suscripcionId } : {};
        return this.http.post<any>(`${apiUrl}/programacion/${id}/notificar-manual`, body, { headers });
    }

    getTurnosCatalog(limit = 50, offset = 0) {
        const headers = getHeaders();
        return this.http.get<any>(`${apiUrl}/catalogs-data/Turnos?limit=${limit}&offset=${offset}`, { headers });
    }

    getRutasCatalog(limit = 200, offset = 0) {
        const headers = getHeaders();
        return this.http.get<any>(`${apiUrl}/catalogs-data/CleaningRoutes?limit=${limit}&offset=${offset}`, { headers });
    }

    getWhatsappNotificacionesConfig() {
        const headers = getHeaders();
        return this.http.get<any>(`${apiUrl}/config/whatsapp-notificaciones`, { headers });
    }

    setWhatsappNotificacionesConfig(enabled: boolean) {
        const headers = getHeaders();
        return this.http.put<any>(`${apiUrl}/config/whatsapp-notificaciones`, { enabled }, { headers });
    }

    // ── Bitácoras Limpia Pública ─────────────────────────────────────────────

    getLimpiaPublicaDashboard() {
        const headers = getHeaders();
        return this.http.get<any>(`${apiUrl}/limpia-publica/dashboard`, { headers });
    }

    getBitacoraRecorridos(params: {
        limit?: number; offset?: number;
        fecha?: string; unidad_id?: number | string; ruta_id?: number | string; turno_id?: number | string;
    } = {}) {
        const headers = getHeaders();
        const q = new URLSearchParams();
        if (params.limit != null)     q.set('limit',     String(params.limit));
        if (params.offset != null)    q.set('offset',    String(params.offset));
        if (params.fecha)             q.set('fecha',     params.fecha);
        if (params.unidad_id != null && params.unidad_id !== '') q.set('unidad_id', String(params.unidad_id));
        if (params.ruta_id != null && params.ruta_id !== '')     q.set('ruta_id',   String(params.ruta_id));
        if (params.turno_id != null && params.turno_id !== '')    q.set('turno_id',  String(params.turno_id));
        const qs = q.toString() ? `?${q.toString()}` : '';
        return this.http.get<any>(`${apiUrl}/limpia-publica/bitacora-recorridos${qs}`, { headers });
    }

    getNotificacionesWa(params: {
        limit?: number; offset?: number;
        fecha?: string; telefono?: string; estado?: string;
    } = {}) {
        const headers = getHeaders();
        const q = new URLSearchParams();
        if (params.limit != null)  q.set('limit',  String(params.limit));
        if (params.offset != null) q.set('offset', String(params.offset));
        if (params.fecha)          q.set('fecha',  params.fecha);
        if (params.telefono)       q.set('telefono', params.telefono);
        if (params.estado)         q.set('estado',   params.estado);
        const qs = q.toString() ? `?${q.toString()}` : '';
        return this.http.get<any>(`${apiUrl}/limpia-publica/notificaciones${qs}`, { headers });
    }

    getTrackingApiLog(params: {
        limit?: number; offset?: number;
        endpoint?: string; trigger?: string; fecha?: string;
    } = {}) {
        const headers = getHeaders();
        const q = new URLSearchParams();
        if (params.limit != null)   q.set('limit',    String(params.limit));
        if (params.offset != null)  q.set('offset',   String(params.offset));
        if (params.endpoint)        q.set('endpoint', params.endpoint);
        if (params.trigger)         q.set('trigger',  params.trigger);
        if (params.fecha)           q.set('fecha',    params.fecha);
        const qs = q.toString() ? `?${q.toString()}` : '';
        return this.http.get<any>(`${apiUrl}/tracking/api-log${qs}`, { headers });
    }

    getTrackingApiLogById(id: number) {
        const headers = getHeaders();
        return this.http.get<any>(`${apiUrl}/tracking/api-log/${id}`, { headers });
    }

    trackingResetRateLimit() {
        const headers = getHeaders();
        return this.http.post<any>(`${apiUrl}/tracking/reset-rate-limit`, {}, { headers });
    }

    trackingResumeSyncJob() {
        const headers = getHeaders();
        return this.http.post<any>(`${apiUrl}/tracking/resume-sync-job`, {}, { headers });
    }
}